/* globals mp, SplitText, TimelineMax, Expo */
/* eslint no-unused-expressions: 0, babel/no-unused-expressions: 0 */

import './vendor/TweenMax.min.es5';
import './vendor/jquery.paroller.min.es5';
import './vendor/same-height';
import './vendor/SplitTextPlugin.es5';
import './vendor/tab.es5';

export class ThemeUtil {
  static initNavMobile() {
    $(`.navmain li`).each(function () {
      const item = $(this);
      const drop = item.find(`.dropdown`);
      const link = item.find(`a`).eq(0);
      if (drop.length) {
        item.addClass(`hasdrop`);
        if (link.length) link.addClass(`hasdrop-a`);
      }
    });

    const opener = $(`.hasdrop-a`);
    let dropParent;

    opener.click(function () {
      dropParent = $(this).closest(`.navmain > ul > li`);
      dropParent.siblings().find(`.dropdown`).slideUp(300);
      dropParent.siblings().removeClass(`drop-active`);
      dropParent.find(`.dropdown`).slideToggle(300);
      dropParent.toggleClass(`drop-active`);

      return false;
    });

    $(`.hasdrop.drop-active .dropdown`).show();

    $(`.navmain-trigger`).click(function () {
      $(`body`).toggleClass(`navmain-active`);
      return false;
    });

    $(`.partner-sticky-header .links a`).click(function () {
      $(`body`).removeClass(`navmain-active`);
    });
  }

  static sameHeight() {
    jQuery(`.js-height`).sameHeight({
      elements: `.js-h1`,
      flexible: true,
      multiLine: true,
    });
    jQuery(`.js-height`).sameHeight({
      elements: `.js-h2`,
      flexible: true,
      multiLine: true,
    });
    jQuery(`.js-height`).sameHeight({
      elements: `.js-h3`,
      flexible: true,
      multiLine: true,
    });
  }

  static initTabs() {
    jQuery(`.tabset, .js-tabset`).tabset({
      tabLinks: `a`,
      defaultTab: true,
    });
  }

  static initFixedHeader() {
    let lastScroll = jQuery(window).scrollTop();
    jQuery(window).on(`scroll`, function () {
      if (jQuery(`body`).hasClass(`navmain-active`) && window.innerWidth < 1024) return;
      const win = jQuery(window),
        currentScroll = win.scrollTop(),
        header = jQuery(`.header-new`);
      if (currentScroll > lastScroll) {
        if (currentScroll > 0) {
          header.addClass(`header-sticky`);
          if (header.hasClass(`header-visible`)) {
            header.removeClass(`header-visible`);
          }
        }
      } else {
        if (currentScroll < lastScroll) {
          header.addClass(`header-sticky`).addClass(`header-visible`);

          if (currentScroll === 0) {
            header.removeClass(`header-sticky header-visible`);
          }
        }
      }
      lastScroll = currentScroll;
    });
    jQuery(window).scroll();
  }

  /**
   * This initializes the phone-sized Starter/Growth/Enterprise tab functionality.
   */
  static initToggle() {
    jQuery(`[data-click="menu-a"] a`).click(function (ev) {
      ev.preventDefault();

      // When a tab is clicked, set data-active-plan="growth" (or starter,
      // enterprise) on the containing <section />.

      const selectedPlan = $(this).text().toLowerCase();
      $(this).closest(`section`).attr(`data-active-plan`, selectedPlan);
    });
  }

  static initAnimations() {
    const animations = {
      latestKnownScrollY: 0,
      ticking: false,
      preventAppearingAnimation: true,
      cache: {
        $html: $(`html`),
        $body: $(document.body),
        $window: $(window),
      },
      init() {
        this.onResize();
        this.initParallax();
        this.initHeroAnimations();
        this.initListeners();
        this.initGoTo();
      },
      onResize() {
        this.cache.mediaWidth = window.innerWidth;
        this.cache.clientWidth = this.cache.$window.width();
        this.cache.clientHeight = this.cache.$window.height();
      },
      initListeners() {
        this.cache.$window.on(`resize`, this.onResize.bind(this));
        this.cache.$window.on(`scroll`, this.onScroll.bind(this)).scroll();
      },
      initParallax() {
        $(`[data-parallax-item]`).paroller({
          type: `foreground`,
        });
      },
      initHeroAnimations() {
        if (jQuery(`.js-hero .js-title`).length === 0) return false;

        const self = this;
        self.preventAppearingAnimation = this.cache.$window.scrollTop() < 100;

        const heroTitleSplitText = new SplitText(`.js-hero .js-title`, {type: `words`, wordsClass: `js-letter`});
        const heroTitleChars = heroTitleSplitText.words;

        heroTitleChars.forEach(function (t) {
          // This is trusted content already on the page, we're just wrapping it
          // eslint-disable-next-line no-unsanitized/property
          return (t.innerHTML = `<div class="js-inner">` + t.innerHTML + `</div>`);
        });

        const heroTitleLetters = jQuery(`.js-hero .js-title .js-inner`);
        const animationTimeout = 25;

        setTimeout(function () {
          jQuery(`.js-hero .js-hero-content`).addClass(`visible`);
          let completedAnimation = false;
          const completeEdge = $(`.js-hero-image`).length > 0 ? 0.8 : 0.5;
          new TimelineMax({
            onUpdate() {
              if (this.progress() > completeEdge && !completedAnimation) {
                completedAnimation = true;
                self.preventAppearingAnimation = false;
                self.cache.$window.scroll();
              }
            },
          })
            .to(`.js-hero .js-subtitle`, 1.1, {opacity: 1, y: 0, ease: Expo.easeOut})
            .staggerTo(heroTitleLetters, 1.5, {y: `0%`, ease: Expo.easeOut}, 0.06, `-=0.8`)
            .staggerTo(`.js-hero .js-copy`, 1.1, {opacity: 1, y: 0, ease: Expo.easeOut}, 0.3, `-=0.8`)
            .fromTo(`.js-hero-image`, 1.1, {opacity: 0, y: 20}, {opacity: 1, y: 0, ease: Expo.easeOut}, `-=0.8`);
        }, animationTimeout);
      },
      requestTick() {
        if (!this.ticking) {
          requestAnimationFrame(this.update.bind(this));
        }
        this.ticking = true;
      },
      onScroll() {
        this.latestKnownScrollY = this.cache.$window.scrollTop();
        this.requestTick();
      },
      update() {
        const self = this;
        this.ticking = false;
        const scrollTop = this.latestKnownScrollY;
        const scrollBottom = this.latestKnownScrollY + this.cache.clientHeight;

        /* Appearing Animations*/

        if (!this.preventAppearingAnimation) {
          if (typeof this.appearingBlocks !== `undefined` && this.appearingBlocks.length) {
            this.appearingBlocks.not(`.is-appeared`).each(function (index, item) {
              const el = $(item),
                appearOffset = typeof el.data(`appearOffset`) !== `undefined` ? el.data(`appearOffset`) : 0.05;

              if (el.isInViewportWithOffset(scrollTop, scrollBottom, appearOffset, self.cache.clientHeight)) {
                el.addClass(`is-appeared`);
              }
            });
          }

          if (typeof this.appearingGroups !== `undefined` && this.appearingGroups.length) {
            // eslint-disable-next-line sonarjs/no-identical-functions
            this.appearingGroups.not(`.is-appeared`).each(function (index, item) {
              const el = $(item),
                appearOffset = typeof el.data(`appearOffset`) !== `undefined` ? el.data(`appearOffset`) : 0.05;

              if (el.isInViewportWithOffset(scrollTop, scrollBottom, appearOffset, self.cache.clientHeight)) {
                el.addClass(`is-appeared`);
              }
            });
          }

          if (typeof this.appearingCommons !== `undefined` && this.appearingCommons.length) {
            // eslint-disable-next-line sonarjs/no-identical-functions
            this.appearingCommons.not(`.is-appeared`).each(function (index, item) {
              const el = $(item),
                appearOffset = typeof el.data(`appearOffset`) !== `undefined` ? el.data(`appearOffset`) : 0.05;
              if (el.isInViewportWithOffset(scrollTop, scrollBottom, appearOffset, self.cache.clientHeight)) {
                el.addClass(`is-appeared`);
              }
            });
          }
        }

        /* Appearing Animations END*/
      },
      initGoTo() {
        this.link = $(`[data-go-to]`);
        if (this.link.length === 0) return false;
        this.link.click(function () {
          if (
            location.pathname.replace(/^\//, ``) === this.pathname.replace(/^\//, ``) &&
            location.hostname === this.hostname
          ) {
            let target = jQuery(this.hash);
            target = target.length ? target : jQuery(`[name=` + this.hash.slice(1) + `]`);
            if (target.length) {
              jQuery(`html, body`).animate(
                {
                  scrollTop: target.offset().top,
                },
                1000,
              );
              return false;
            }
          }
        });
      },
    };

    animations.init();
  }

  static initMarketingTheme() {
    $.fn.isInViewportWithOffset = function (scrollTop, scrollBottom, _offset, _clientHeight) {
      const el = jQuery(this);
      const elementTop = el.offset().top;
      const offset = _clientHeight * _offset;
      const viewportBottom = scrollBottom - offset;
      return viewportBottom > elementTop;
    };

    ThemeUtil.initNavMobile();
    ThemeUtil.sameHeight();
    ThemeUtil.initTabs();
    ThemeUtil.initFixedHeader();
    ThemeUtil.initAnimations();
    ThemeUtil.initToggle();
  }
}

mp.utility.onDocumentReady(() => ThemeUtil.initMarketingTheme());
